import { Helmet } from "react-helmet";
import FrontImage from "../Assets/Images/Front_Image.png";
import "./Home.css";
import Typewriter from "typewriter-effect";
import GoogleReviewSection from "./GoogleReviewSection.js";
import ServiceCard from "./ServiceCard.js";
import Section4 from "./Section4.js";
import LogoSection from "./LogoSection.js";
import WhatWeDoSection from "./WhatWeDoSection.js";


const Home = () => {

  return (
    <main>
      <Helmet> <title>US Tax & Bookkeeping Services | Outsourced from India | BooksComply</title>
        <meta name="description"
          content="BooksComply provides expert US tax filing, bookkeeping, CFO advisory, and USA business incorporation services from India. 
       Trusted by clients across the USA." />
        <meta name="keywords"
          content="US Tax Filing from India, USA Bookkeeping Services, Outsourced Accounting, Indian CPA for US Tax, 1099 Filing, 
        CFO Advisory USA, Incorporate Business in USA, Virtual Bookkeeping USA, Remote CPA Services, Affordable Bookkeeping USA" />
        <meta name="robots" content="index, follow" /> <meta property="og:title"
          content="US Tax & Bookkeeping Experts | BooksComply" /> <meta property="og:description"
            content="Expert US tax filing, virtual bookkeeping, CFO advisory, and incorporation services for US clients from India." />
        <meta property="og:image" content="https://bookscomply.com/assets/Images/Front_Image.png" /> <meta property="og:url"
          content="https://bookscomply.com" /> <meta name="twitter:card" content="summary_large_image" />
      </Helmet>


      <section id="homeSection" className="bg-light pt-5 pb-3">
        <div className="container">
          <div className="row align-items-center">
            {/* Left Column: Taglines */}
            <div className="col-md-6">
              <h1 className="display-3 fw-bolder mb-3">
                <span className="text-black-force">Your Trusted Partner</span>
                <br />
                <span className="for-seamless-black">for Seamless </span>
                <span className="typewriter-text text-accent fw-normal font-change font-change1">
                  <Typewriter
                    options={{
                      strings: ["Bookkeeping", "CFO Advisory", "USA Business Incoporation", "Tax Return"],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 10,
                    }}
                  />
                </span>
              </h1>
              <p className="lead mt-4 text-black-force" style={{ color: '#000000' }}>
                Setup your business in USA and Empower with seamless Bookkeeping,Taxation and CFO advisory services.
                Let us handle the numbers while you focus on growth.
              </p>
              <button
                className="btn btn-primary-1 rounded-pill px-4 py-2 mt-3"
                onClick={() => window.location.href = '/pricing'}
              >
                View Pricing
              </button>
            </div>

            {/* Right Column: Image */}
            <div className="col-md-6 text-center">
              <div className="front-image-wrap">
                <img
                  src={FrontImage}
                  alt="Bookkeeping Services"
                  className="front-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ServiceCard />
      <WhatWeDoSection />
      <GoogleReviewSection />
      <Section4 />
      <LogoSection />
    </main>
  );
};
export default Home;